import { createSelector } from 'reselect';
import { manInSuitImg } from 'theme/icon';

const currencyPointer = state => state.dictionary.currency;
const cardParticipantsPointer = state => state.tenderCard.cardParticipants;
const tenderCardInfoPointer = state => state.tenderCard.info;
const accessFillingProtocolPointer = state => state.login.access.dopFunc.isFillingProtocol;
const loginPointer = state => state.login;

const getPicture = (picture, firmTypeId) => {
  if (picture) {
    return picture;
  }
  if (firmTypeId === 2) {
    return manInSuitImg;
  }
  return 'https://t0003.myseldon.com/content/img/company-pics/256/opf/4.png';
};

export default createSelector(
  [currencyPointer, cardParticipantsPointer, accessFillingProtocolPointer, tenderCardInfoPointer, loginPointer],
  (currency, cardParticipants, accessFillingProtocol, tenderCard, login) => {
    const { participants: defaultParticipants = [], price: priceTender, isCustomTender } = tenderCard;
    const {
      access: { sectionAccess },
    } = login;

    const items = (cardParticipants || []).map(c => ({
      ...c,
      picture: getPicture(c.picture, c.firmTypeId),
      dif: priceTender && c.price ? ((c.price * 100) / priceTender - 100).toFixed(2) : null,
    }));

    let statistic = {
      typeStatistic: 1,
      count: 0,
      allow: 0,
      winners: [],
    };
    if (items.length > 0) {
      statistic = {
        typeStatistic: 1,
        count: items.length,
        allow: items.filter(x => x.allowed).length,
        winners: items.filter(x => x.winner && x.refuseContract === false),
      };
    } else if (defaultParticipants.length > 0) {
      statistic = {
        typeStatistic: 2,
        count: defaultParticipants.length,
        allow: defaultParticipants.filter(x => x.allowed).length,
        winners: defaultParticipants.filter(x => x.winner && x.refuse === false),
      };
    }
    return {
      dictionary: {
        currency,
        currencySymbol: currency.map(x => ({
          id: x.id,
          name: x.symbol,
        })),
      },
      statistic,
      items,
      access: {
        fillingProtocol: accessFillingProtocol && !isCustomTender && defaultParticipants.length > 0,
        isParticipantsActive: sectionAccess['4'],
      },
    };
  },
);
